import { Container } from "@mui/material";
import Main from "./pages/Main";

function App() {
  return (
    <Container>
      <Main />
    </Container>
  );
}

export default App;
